/**
 * @description VRM Remote console config
 */

// Import the service and controllers
import "./remote-console-2.service.js";
import "./remote-console-embedded.controller.js";
import "./remote-console-choice.controller.js";

(function() {
    "use strict";

    angular.module("vrm.core").config(RemoteConsoleRoute);

    /**
     * Configure Routing for Login State
     * @param $stateProvider
     * @constructor
     * @ngInject
     */
    function RemoteConsoleRoute($stateProvider) {
        const modalViews = {
            base: {
                template: require("@/angular/views/core/remote-console-2.html"),
                controller: "RemoteConsoleController2"
            }
        };
        const embeddedViews = {
            base: {
                template: require("@/angular/views/core/remote-console-embedded.html"),
                controller: "RemoteConsoleEmbeddedController"
            }
        };
        const choiceViews = {
            base: {
                template: require("@/angular/views/core/remote-console-choice.html"),
                controller: "RemoteConsoleChoiceController"
            }
        };
        $stateProvider
            .state("remote-console-2", {
                url: "/remote-console-2/{id:int}",
                views: modalViews,
                data: {
                    requiresVnc: true
                }
            })
            .state("remote-console-choice", {
                url: "/remote-console-choice/{id:int}",
                views: choiceViews,
                data: {
                    requiresVnc: true
                }
            })
            .state("installations-remote-console", {
                url: "/installation/{id:int}/remote-console",
                views: embeddedViews,
                data: {
                    requiresVnc: true
                }
            });
    }
})();
